module.exports = __webpack_public_path__ + "static/img/biao.5f807bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/biao.png
// module id = ZN7S
// module chunks = 0